export default "__VITE_PUBLIC_ASSET__a56b5731__"